import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-museum-galleries-list',
  templateUrl: './museum-galleries-list.component.html',
  styleUrls: ['./museum-galleries-list.component.css']
})
export class MuseumGalleriesListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
